<template>

    <div class="hc">

        <div class="hc__side"></div>

        <button class="hc__btn"
                :class="{
            'hc__active': category === ENUM.NEWSLETTERS.CATEGORIES.ALL,
            'text-baseRegular': category !== ENUM.NEWSLETTERS.CATEGORIES.ALL && !isDesktop,
            'text-baseSemibold': category === ENUM.NEWSLETTERS.CATEGORIES.ALL && !isDesktop,
            'text-lRegular': category !== ENUM.NEWSLETTERS.CATEGORIES.ALL && isDesktop,
            'text-lSemibold': category === ENUM.NEWSLETTERS.CATEGORIES.ALL && isDesktop,
        }"
                @click="updateCategory(ENUM.NEWSLETTERS.CATEGORIES.ALL)">
            <p>{{ $t('cleaning_header_all') }}</p>
            <div class="hc__highlight">
                <span class="text-sRegular">{{ countTotal }}</span>
            </div>
        </button>

        <button class="hc__btn"
                :class="{
            'hc__active': category === ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS,
            'text-baseRegular': category !== ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS && !isDesktop,
            'text-baseSemibold': category === ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS && !isDesktop,
            'text-lRegular': category !== ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS && isDesktop,
            'text-lSemibold': category === ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS && isDesktop,
        }"
                @click="updateCategory(ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS)">
            <p>{{ $t('cleaning_title') }}</p>
            <div class="hc__highlight">
                <span class="text-sRegular">{{ countNewsletters }}</span>
            </div>
        </button>

        <button class="hc__btn"
                :class="{
            'hc__active': category === ENUM.NEWSLETTERS.CATEGORIES.SPAMS,
            'text-baseRegular': category !== ENUM.NEWSLETTERS.CATEGORIES.SPAMS && !isDesktop,
            'text-baseSemibold': category === ENUM.NEWSLETTERS.CATEGORIES.SPAMS && !isDesktop,
            'text-lRegular': category !== ENUM.NEWSLETTERS.CATEGORIES.SPAMS && isDesktop,
            'text-lSemibold': category === ENUM.NEWSLETTERS.CATEGORIES.SPAMS && isDesktop,
        }"
                @click="updateCategory(ENUM.NEWSLETTERS.CATEGORIES.SPAMS)">
            <p>{{ $t('spam') }}</p>
            <div class="hc__highlight">
                <span class="text-sRegular">{{ countSpams }}</span>
            </div>
        </button>

        <div class="hc__side"></div>
    </div>

</template>

<script>
import ENUM from '@/assets/ENUM'

import Subscription from '@/helpers/subscription'

import Tag from '@/modules/tag'

export default {

    name: 'newsletters-header-categories',

    props: {

        category: {
            type: String,
            default: ''
        },


        subscriptions: {
            type: Array,
            default: () => []
        },
    },

    computed: {
        ENUM() {
            return ENUM
        },

        Subscription() {
            return Subscription
        },

        countTotal() {
            return this.subscriptions && this.subscriptions.length
        },

        countNewsletters() {
            return this.countTotal - this.countSpams
        },

        countSpams() {
            return this.subscriptions && this.subscriptions.filter(subscription => Subscription.isSpoum(subscription)).length
        },
    },

    methods: {
        updateCategory(newCategory) {
            switch (newCategory) {
                case ENUM.NEWSLETTERS.CATEGORIES.ALL:
                    Tag.pageViewGA(this, 'tab_all')
                    break
                case ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS:
                    Tag.pageViewGA(this, 'tab_newsletters')
                    break
                case ENUM.NEWSLETTERS.CATEGORIES.SPAMS:
                    Tag.pageViewGA(this, 'tab_spams')
                    break
            }
            this.$emit('updateCategory', newCategory)
        }
    }
}
</script>

<style lang="scss" scoped>

.hc {

    display: flex;
    flex-direction: row;

    @media screen and (min-width: $above-tablet-length) {
        background-color: $timberwolf;
    }

    &__btn {
        display: flex;
        flex: 1;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: $timberwolf;
        padding: 16px 24px 8px;
        color: $neutralsMoon;
        border-bottom: 2px solid $silver;

        @media screen and (min-width: $above-tablet-length) {
            padding: 24px 16px 8px;
            flex: none;
        }
    }

    &__active {
        border-color: $aquamarine;
        color: $blue;
        @media screen and (min-width: $above-tablet-length) {
            border-bottom: 2px solid $aquamarine;
            background-color: $timberwolf;
        }
    }

    &__highlight {
        padding: 2px 6px;
        background-color: $aquamarine;
        color: $white;
        border-radius: 72px;
        min-width: 24px;
        margin-left: 6px;
        display: flex;
        justify-content: center;

        &:lang(ar-sa) {
            margin-right: 6px;
            margin-left: 0;
        }
    }

    &__side {
        border-bottom: 2px solid $silver;
        @media screen and (min-width: $above-tablet-length) {
            flex: 1;
        }
    }
}
</style>
